export default __webpack_public_path__ + "static/media/higher_icon_calendar_blue.7d4ebd82.svg";